import React, { useEffect, useState } from 'react';
import PGPDecryptor from './components/PGPDecryptor';
import PgpEncryptor from './components/PGPEncryptor';
import PGPKeyGenerator from './components/PGPKeyGenerator';
import MessagingApp from './components/MessagingApp';
import './App.css';

function App() {
  const [activeTab, setActiveTab] = useState("messaging");
  const [darkMode, setDarkMode] = useState(false);
  const [prefilledMessage, setPrefilledMessage] = useState("");
  const [prefilledDecrypt, setPrefilledDecrypt] = useState("");

  useEffect(() => {
    document.body.classList.toggle('dark', darkMode);
  }, [darkMode]);

  return (
    <div className="app-container">
      <nav className="menu">
        <button
          className={activeTab === "messaging" ? "active" : ""}
          onClick={() => setActiveTab("messaging")}
        >
          Messaging
        </button>
        <button 
          className={activeTab === "decrypt" ? "active" : ""}
          onClick={() => setActiveTab("decrypt")}
        >
          Decrypt
        </button>
        <button 
          className={activeTab === "encrypt" ? "active" : ""}
          onClick={() => setActiveTab("encrypt")}
        >
          Encrypt
        </button>
        <button
          className={activeTab === "generate" ? "active" : ""}
          onClick={() => setActiveTab("generate")}
        >
          Generate Keys
        </button>
        <button
          className="toggle-theme"
          onClick={() => setDarkMode(!darkMode)}
        >
          {darkMode ? "Light Mode" : "Dark Mode"}
        </button>
      </nav>
      
      <div className="tab-content">
        {activeTab === "messaging" && (
          <MessagingApp
            prefilledMessage={prefilledMessage}
            setPrefilledMessage={setPrefilledMessage}
            onDecryptMessage={(msg) => {
              setPrefilledDecrypt(msg);
              setActiveTab("decrypt");
            }}
          />
        )}
        {activeTab === "decrypt" && (
          <PGPDecryptor
            prefilledEncrypted={prefilledDecrypt}
            setPrefilledEncrypted={setPrefilledDecrypt}
          />
        )}

        {activeTab === "encrypt" && (
          <PgpEncryptor
            onSendViaMessaging={(msg) => {
              setPrefilledMessage(msg);
              setActiveTab("messaging");
            }}
          />
        )}
        {activeTab === "generate" && <PGPKeyGenerator />}
      </div>
    </div>
  );
}

export default App;
